import { QuestionAttribute } from "@components/BuilderComponents/SignupFormDrip/sfd-components/Form/sfd-helpers/sfd-form.type";

export const formData = {
  agreement: {
    checked: false,
    hasError: false,
    isValid: false,
  },
  email: {
    value: "",
    hasError: false,
    isValid: false,
  },
  firstName: {
    value: "",
    hasError: false,
    isValid: false,
  },
  lastName: {
    value: "",
    hasError: false,
    isValid: false,
  },
  password: {
    value: "",
    hasError: false,
    isValid: false,
    validators: {
      lowerLetter: false,
      oneNumber: false,
      uppercaseLetter: false,
      charactersMin: false,
    },
  },
  phone: {
    value: "",
    hasError: false,
    isValid: false,
  },
  profession: {
    value: "",
    hasError: false,
    isValid: false,
  },
  otherProfession: {
    value: "",
    hasError: false,
    isValid: false,
  },
  questions: {},
};

export type UseFormDataState = typeof formData & {
  offer?: {
    promoCode: string;
  };
};

export type FormDataKey = keyof UseFormDataState;
export type DataForSubmissionType = {
  email: string;
  firstName: string;
  globalProfessionId: string;
  lastName: string;
  otherProfession: string;
  password: string;
  phoneNumber: string;
  termsOfServiceAcceptance: boolean;
  questions: QuestionAttribute;
  offer?: string | null;
  offerPromoCode?: string | null;
};

export type QuestionValue = {
  name: string;
  value: string;
  hasError: boolean;
  isValid?: boolean;
};
